import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";

@Component({
  selector: "app-archers",
  templateUrl: "./archers.component.html",
  styleUrls: ["./archers.component.css"],
})
export class ArchersComponent implements OnInit {
  cols: any = [];
  ArcherData: any;
  name: any = "";
  genderFilter: any = "";
  categoryFilter: any = "";
  genderList: any = [];
  playingCategory: any = [];
  ArcherMainData: any;
  pageCount: any = 1;

  constructor(
    private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {
    this.cols.length = 40;
    this.genderList = [
      { label: "Male", value: "Male" },
      { label: "Female", value: "Female" },
    ];

    this.playingCategory = [
      { label: "Indian Round", value: "Indian Round" },
      { label: "Compound", value: "Compound" },
      { label: "Recurve", value: "Recurve" },
      { label: "Para", value: "Para" },
    ];
  }

  ngOnInit(): void {
    this.getDetails();
  }
  getDetails() {
    const url =
      this.global.basePath +
      "common/archerinfo?gender=" +
      this.genderFilter +
      "&name=" +
      this.name +
      "&playingCategory=" +
      this.categoryFilter +
      "&page=" +
      this.pageCount;
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      console.log(
        "🚀 ~ file: archers.component.ts ~ line 30 ~ ArchersComponent ~ this.global.GetRequest ~ res",
        res
      );
      this.ArcherMainData = res[0].json;
      const data = res[0].json.approved;
      this.ArcherData = data;
    });
  }

  FilterByName(e: any) {
    console.log(e, "target value");
    this.getDetails();
  }
  filterByGender(event) {
    this.genderFilter = event.value;
    this.getDetails();
  }

  filterByCategory(event) {
    this.categoryFilter = event.value;
    this.getDetails();
  }

  ClearFilters() {
    this.name = "";
    this.genderFilter = "";
    this.getDetails();
  }

  paginate(event: any) {
    this.pageCount = event.page + 1;
    this.getDetails();
    window.scrollTo(0, 0);
  }
}
